<template>
  <b-modal
      id="scanner-modal-info"
      no-footer
      title="Information"
      :backdrop="'static'"
      @hide="onHide"
  >
    <empty-state
        statusIcon="info"
        statusIconSize="4x"
        :title="modalTitle"
        :subtitle="modalMessage"
    />
    <template v-slot:modal-footer>
      <button type="button" class="btn btn-success" @click="confirm">Confirm</button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalTitle: {
      type: String,
      default: "Notice",
    },
    modalMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      allowClose: false,
    };
  },
  methods: {
    confirm() {
      this.allowClose = true;
      this.$emit("modalConfirmed");
    },
    onHide(event) {
      if (!this.allowClose) {
        event.preventDefault();
      }
    },
  },
};
</script>